// src/pages/caseManagement/CaseManagement.tsx

import React from 'react';
import CaseManagementDashboard from 'containers/pages/caseManagement/CaseManagementDashboard';

function CaseManagement() {
  return <CaseManagementDashboard />;
}

export default CaseManagement;
